import React, { useState, useEffect } from 'react';
import { Alert, Card, CardBody, Col, Row, Progress } from 'reactstrap';
import FeatherIcon from "feather-icons-react";
import { Link } from 'react-router-dom';
import illustarator from "../../../assets/images/user-illustarator-2.png";
import subscriptionData from './fakedata/subscription_detail.json';

const UpgradeAccountNotice = () => {
    const [used, setUsed] = useState(0);
    const [total, setTotal] = useState(subscriptionData.total);
    const [remaining, setRemaining] = useState(0);
    const [percentageUsed, setPercentageUsed] = useState(0);

    useEffect(() => {
        const usedUsage = Object.values(subscriptionData.monthlyUsage).reduce((acc, month) => {
            return acc + Object.values(month).reduce((monthAcc, week) => monthAcc + week, 0);
        }, 0);
        setUsed(usedUsage);
        setRemaining(total - usedUsage);
        setPercentageUsed((usedUsage / total) * 100);
    }, [total]);

    return (
        <React.Fragment>
            <Row>
                <Col xs={12}>
                    <Card>
                        <CardBody className="p-0">
                            <Alert className="alert alert-warning border-0 rounded-0 m-0 d-flex align-items-center" role="alert">
                                <FeatherIcon
                                    icon="alert-triangle"
                                    className="text-warning me-2 icon-sm"
                                />
                                <div className="flex-grow-1 text-truncate">
                                    Your plan expires on <b>{new Date(subscriptionData.expireDate).toLocaleDateString()}</b>.
                                </div>
                                <div className="flex-shrink-0">
                                    <Link className="text-reset text-decoration-underline"><b>Upgrade</b></Link>
                                </div>
                            </Alert>

                            <Row className="align-items-end">
                                <Col sm={8}>
                                    <div className="p-3">
                                        <p className="fs-16 lh-base">
                                            Upgrade your plan to enjoy uninterrupted services. 
                                        </p>
                                    </div>
                                </Col>
                                <Col sm={4}>
                                    <div className="px-3">
                                        <img src={illustarator} className="img-fluid" alt="" />
                                    </div>
                                </Col>
                            </Row>

                            <div className="px-3 pb-3">
                                <h6 className="text-muted">Usage Progress</h6>
                                <Progress 
                                    value={percentageUsed} 
                                    className="rounded-pill" 
                                    style={{ height: '1.3rem' }}  // Adjust the height as needed
                                >
                                    {Math.round(percentageUsed)}%
                                </Progress>
                                <div className="d-flex justify-content-between mt-2">
                                    <span className="text-muted">Used: {used.toLocaleString()}</span>
                                    <span className="text-muted">Remaining: {remaining.toLocaleString()}</span>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default UpgradeAccountNotice;
